import {AfterViewInit, Component, OnInit} from '@angular/core';
import {language} from '../../../language/vn';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {CommandUtil} from '../../../global/commandutil';
import {LogSearchService} from '../../../service/search/service-logsearch';
import {LogSearch} from '../../../models/search/logsearch';
import {environment} from '../../../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import {Sessioncommand} from '../../../global/sessioncommand';
import {FormatService} from '../../../service/format/service-format';
import {Staffs} from '../../../models/staff/staffs';
@Component({
  templateUrl: './logsearch.component.html'
})
export class LogSearchComponent implements OnInit, AfterViewInit {
  public language = language;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public totalItems: number = 0;
  public selectSearch: Subject<string>;
  public dataList: LogSearch[] = [];
  public  onClose: Subject<boolean>;
  public srFromDate: Date = new Date();
  public srToDate: Date= new Date();
  public strF: string= '';
  public strT: string= '';
  public searchForm: string='';
  public srTuKhoa: string ='';
  constructor(  public logSearchService: LogSearchService,
                public bsModalService: BsModalService,
                public formatService: FormatService,
                public datePipe: DatePipe,
                public toastr: ToastrService,
                public _bsModalRef: BsModalRef,
                public commandUtils: CommandUtil
  ) {
  }
  ngAfterViewInit() {

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  search()
  {   this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
      this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
      this.logSearchService.getCountByKeyword(Sessioncommand.staffId, this.srTuKhoa, this.searchForm, this.strF, this.strT).subscribe(data => this.totalItems = data);
      this.logSearchService.findAllByPaging(Sessioncommand.staffId, this.srTuKhoa, this.searchForm, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(data => this.dataList =data);

  }
  public edit(type: string) {
    this.formatService.getFirstLastCurrentByMonth().subscribe(
      data => {
        this.srFromDate= new Date(data.firstDate);
        this.srToDate= new Date(data.lastDate);
        this.searchForm = type;
        this.search();
      });
  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.selectSearch = new Subject();

  }
  deleteItem(id: number)
  {
    this.logSearchService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  public onSelect(params: string): void {
    this.selectSearch.next(params);
    this._bsModalRef.hide();
  }
  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();
  }
}

